import tw from "src/utils/tw";

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const MainContent = (props: Props) => {
  return (
    <div
      className={tw(
        "flex",
        "flex-col",
        "flex-1",
        "md:overflow-hidden",
        // "sm:block",
        props.className
      )}
    >
      {props.children}
    </div>
  );
};

export default MainContent;
